module.exports = __webpack_public_path__ + "img/personal-photo.8b45fec0.jpeg";